<app-main-page>
 <app-card-lg [routerLink]="'warehouses'" [title]="'Warehouses'"></app-card-lg>
 <app-card-lg [routerLink]="'product-inventory'" [title]="'Inventory'"></app-card-lg>
 <app-card-lg [routerLink]="'products'" [title]="'Products'"></app-card-lg>
 <app-card-lg [routerLink]="'transactions'" [title]="'Transactions'"></app-card-lg>
</app-main-page>
